import React, { Component } from 'react';
import { connect } from 'react-redux';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';

import { boardInfoService } from '../../services';
import { alertActions } from '../../modules/alert';

class BoardInfoDel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false
        }
    }

    handleFormSubmit = (e) => {
        e.preventDefault();
        this.delBoardInfo();

        this.setState({
            boardInfoID: '',
            boardName: '',
            boardTypeCoe: '',
            open: false
        });
    }

    handleValueChange = (e) => {
        let nextState = {};
        nextState[e.target.name] = e.target.value;
        this.setState(nextState);
    }


    delBoardInfo = () => {
        boardInfoService.delBoardInfo(this.props.boardInfo.boardInfoID)
            .then((response) => {
                console.log(response.data);
                if(response.data.result){
                    alert('게시판을 삭제하였습니다.');
                    this.props.stateRefresh();
                }else
                    alert('게시판 삭제를 실패하였습니다.');
                
            })
            .catch( this.handleErrors );
    }

    handleErrors = (error) => {
        console.log(error.toString());
        if(error.response===undefined)
            this.props.errorAlerts("알 수 없는 오류가 발생하였습니다. 관리자에게 문의하시기 바랍니다.", "/home");
        else{
            if (error.response.status === 401)
                this.props.errorAlerts("권한이 없습니다.", "/login");
            else
                this.props.errorAlerts(error.response.data.message);
        }
    }

    handleClickOpen = () => {
        this.setState({
            open: true
        })
    }

    handleClose = () => {
        this.setState({
            boardInfoID: '',
            boardName: '',
            boardTypeCoe: '',
            open: false
        });
    }

    render() {
        return (
            <>
                <IconButton aria-label="delete" onClick={this.handleClickOpen}>
                    <DeleteIcon fontSize="small"/>
                </IconButton>
                <Dialog open={this.state.open} onClose={this.handleClose}>
                    <DialogTitle>
                    게시판 삭제
                    </DialogTitle>
                    <DialogContent>
                        {this.props.boardInfo.boardName}을 삭제하시겠습니까?
                    </DialogContent>
                    <DialogActions>
                        <Button variant="contained" color="primary" onClick={this.handleFormSubmit}>삭제</Button>
                        <Button variant="outlined" color="primary" onClick={this.handleClose}>닫기</Button>
                    </DialogActions>
                </Dialog>
            </>
        )
    }
}

function mapState(state) {
    return state;
}

const actionCreators = {
    errorAlerts: alertActions.error,
    successAlerts: alertActions.success
};

export default connect(mapState, actionCreators)(BoardInfoDel);